export default "__VITE_ASSET__rRosMl_P__"